import { useEffect, useState } from 'react';
import { useScrollPosition } from './useScrollPosition';

const HEADER_CHANGE_BREAKPOINT = 50;

export const useHeaderSticky = (): boolean => {
  const scrollPosition = useScrollPosition();
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    setIsSticky(scrollPosition > HEADER_CHANGE_BREAKPOINT);
  }, [scrollPosition]);

  return isSticky;
};
